import { type ReactNode, type RefObject, useEffect, useRef } from 'react'

function MobileVideo({
	reference,
	src,
}: {
	reference: RefObject<HTMLVideoElement>
	src: string
}) {
	return (
		<video
			ref={reference}
			src={src}
			controls={false}
			loop
			muted
			autoPlay
			playsInline
			preload="auto"
			className="inset-0 z-0 h-screen w-full object-cover lg:hidden"
		/>
	)
}

function DesktopVideo({
	reference,
	src,
}: {
	reference: RefObject<HTMLVideoElement>
	src: string
}) {
	return (
		<video
			ref={reference}
			src={src}
			controls={false}
			loop
			muted
			autoPlay
			playsInline
			preload="auto"
			className="inset-0 z-0 hidden h-screen w-full object-cover lg:block"
		/>
	)
}

export function VideoJumbo({
	isIntersectingContent,
	srcMobile,
	srcDesktop,
	children,
}: {
	isIntersectingContent: boolean
	srcMobile: string
	srcDesktop: string
	children?: ReactNode
}) {
	const mobileReference = useRef<HTMLVideoElement>(null)
	const desktopReference = useRef<HTMLVideoElement>(null)

	useEffect(() => {
		// If the content is intersecting, we pause the videos.
		if (isIntersectingContent) {
			mobileReference.current?.pause()
			desktopReference.current?.pause()
		}
		// If the content is not intersecting, we play the videos.
		else {
			void mobileReference.current?.play()
			void desktopReference.current?.play()
		}
	}, [isIntersectingContent])

	return (
		<div className="relative h-full w-full">
			{/* Always render both videos to avoid SSR hydration mismatch. CSS handles visibility. */}
			<DesktopVideo src={srcDesktop} reference={desktopReference} />
			<MobileVideo src={srcMobile} reference={mobileReference} />

			{children}
		</div>
	)
}
